export function launch() {
  return {
    type: 'LAUNCH',
  };
}

export function launchFinished(error = null) {
  return {
    type: 'LAUNCH_FINISHED',
    error,
  };
}

export function syncServerTime(time = 0) {
  return {
    type: 'SYNC_SERVER_TIME',
    time,
  };
}

export function catchError(error = null) {
  return {
    type: 'CATCH_ERROR',
    error,
  };
}

export function setWmpScene(value) {
  return {
    type: 'SET_WMP_SCENE',
    value
  }
}
